/**
 * PlatformConsole — layout de la consola unificada de super_admin.
 *
 * ADR-038 Opción 3: rutas hijas bajo este layout con <Outlet/>.
 * La navegación entre secciones (Tenants · Usuarios · Billing · APIs) vive en
 * el nav superior del AppShell (variant='platform'), única fuente de tabs —
 * no se duplica aquí (feedback Achile 2026-06-01).
 *
 * El guard RequireFullAuth + RequirePlatformAdmin se aplica UNA sola vez en la
 * ruta padre en App.tsx, no se repite aquí.
 */
import { Outlet } from 'react-router-dom';

export function PlatformConsole(): JSX.Element {
  return (
    <div className="min-h-full">
      <Outlet />
    </div>
  );
}
